import React from 'react';
import * as styles from './attention.module.scss';

interface AttentionTypes {}

const Attention: React.FC<AttentionTypes> = ({ children }) => {
  return (
    <div className={styles.pAttention}>
      <b>無料相談実施中！</b>
      {children}
    </div>
  );
};

export default Attention;
